import { Checkbox as AntCheckbox } from 'antd';
import styled from 'styled-components';
import { groupedListStyles } from '../../../assets/styles/components/groupedList';

export const Checkbox = styled(AntCheckbox)``;

export const CheckboxGroup = styled(AntCheckbox.Group)`
  .ant-checkbox-wrapper {
    border: 1px solid var(--clr-border-grey-100);
    border-radius: 5px;
    padding: 9px 10px;
    background-color: var(--clr-container-bg);
    flex-direction: row-reverse;
    line-height: 18px;
    .ant-checkbox-label {
      width: 100%;
      padding-inline: 0;
    }
    &:hover {
      background-color: var(--clr-general-hover);
      .ant-checkbox-inner {
        border-color: var(--clr-general-border-hover);
      }
    }
    &.semi-disabled {
      opacity: 0.5;
      pointer-events: none;
      cursor: not-allowed;
      .ant-checkbox-input {
        cursor: not-allowed;
      }
      &.ant-checkbox-wrapper-checked {
        opacity: 1;
        pointer-events: auto;
        .ant-checkbox-input {
          cursor: not-allowed;
        }
      }
    }
  }
  .ant-checkbox-wrapper-checked {
    border-color: var(--clr-general-primary);
    background-color: var(--selected);
    &:hover {
      background-color: var(--selected-hover);
      border-color: var(--clr-general-primary);
      .ant-checkbox-inner {
        border-color: var(--clr-general-primary);
      }
    }
  }
  &.persons-listing {
    flex-wrap: nowrap;
  }
  &.grouped-list {
    ${groupedListStyles('.ant-checkbox-wrapper')}
  }
`;
